module.exports = __webpack_public_path__ + "static/media/juridique_card.1056cade.jpg";